import { render, staticRenderFns } from "./QuickMsg.vue?vue&type=template&id=ff14895e"
import script from "./QuickMsg.vue?vue&type=script&lang=js"
export * from "./QuickMsg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports